import { ArrowUpRight } from "lucide-react";

const SEO_LINKS = [
  "Website Development",
  "WooCommerce Development",
  "SEO Services",
  "Local SEO",
  "WhatsApp Automation",
  "CRM Setup",
  "AI Automation",
  "Lead Generation Services",
  "Digital Growth Agency",
  "Email Marketing",
  "n8n Automation",
  "Make.com Automation",
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="text-[color:var(--surface-dark-text)] relative"
      style={{ background: "var(--dark)", color: "#f6f5f0" }}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 pt-20 md:pt-28 pb-12">
        <div className="grid grid-cols-12 gap-y-12 md:gap-x-12">
          <div className="col-span-12 md:col-span-7">
            <div className="text-[10px] tracking-[0.3em] uppercase text-white/50 mb-6">
              Ready when you are
            </div>
            <h2 className="font-display text-5xl md:text-7xl lg:text-8xl font-medium tracking-tighter leading-[0.95] text-balance">
              Let's build the next
              <br />
              <span className="font-serif-accent italic font-normal text-white/80">
                chapter
              </span>{" "}
              of your business.
            </h2>
            <a
              href="#contact"
              data-testid="footer-cta"
              className="mt-10 inline-flex items-center gap-2 bg-[color:var(--accent)] text-white px-6 py-3.5 rounded-full font-medium hover:translate-y-[-2px] transition-transform"
            >
              Book a free strategy call
              <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>

          <div className="col-span-12 md:col-span-5 grid grid-cols-2 gap-8 md:pl-8">
            <div>
              <div className="text-[10px] tracking-[0.3em] uppercase text-white/50 mb-4">
                Studio
              </div>
              <ul className="space-y-2 text-sm text-white/80">
                <li>CyberCart Digital LLP</li>
                <li>Based in Navi Mumbai, serving India</li>
                <li>
                  <a
                    href="mailto:info@cybercart.co.in"
                    className="hover:text-white"
                  >
                    info@cybercart.co.in
                  </a>
                </li>
                <li>
                  <a href="tel:+919320201572" className="hover:text-white">
                    +91 93202 01572
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <div className="text-[10px] tracking-[0.3em] uppercase text-white/50 mb-4">
                Sitemap
              </div>
              <ul className="space-y-2 text-sm text-white/80">
                <li>
                  <a href="#services" className="hover:text-white">
                    Services
                  </a>
                </li>
                <li>
                  <a href="#services" className="hover:text-white">
                    Services
                  </a>
                </li>
                <li>
                  <a href="#process" className="hover:text-white">
                    Process
                  </a>
                </li>
                <li>
                  <a href="#about" className="hover:text-white">
                    About
                  </a>
                </li>
                <li>
                  <a href="#faq" className="hover:text-white">
                    FAQ
                  </a>
                </li>
                <li>
                  <a href="#contact" className="hover:text-white">
                    Contact
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-16 md:mt-24 pt-8 border-t border-white/10">
          <div className="text-[10px] tracking-[0.3em] uppercase text-white/50 mb-4">
            Services in Mumbai
          </div>
          <ul className="flex flex-wrap gap-x-5 gap-y-2 text-sm text-white/70">
            {SEO_LINKS.map((s) => (
              <li key={s}>
                <a
                  href="#services"
                  data-testid={`seo-link-${s.replace(/\s+/g, "-").toLowerCase()}`}
                  className="hover:text-white"
                >
                  {s}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-12 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-white/50">
          <div>
            © {new Date().getFullYear()} CyberCart Digital LLP. All rights
            reserved.
          </div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white">
              Privacy
            </a>
            <a href="#" className="hover:text-white">
              Terms
            </a>
            <a href="#" className="hover:text-white">
              Careers
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
